import { forwardRef } from 'react';
import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import styles from './Switch.module.scss';

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  ({ size = 'small', className, ...props }, ref) => {
    return (
      <MuiSwitch
        ref={ref}
        size={size}
        className={[styles.root, className].filter(Boolean).join(' ')}
        classes={{
          root: styles.root,
          switchBase: styles.switchBase,
          checked: styles.checked,
          disabled: styles.disabled,
          input: styles.input,
          thumb: styles.thumb,
          track: styles.track,
          sizeSmall: styles.sizeSmall,
        }}
        {...props}
      />
    );
  }
);

